import { getInvoiceFileResponse } from 'api/evisaAPI/evisaAPI'
import { CallAPIAction, Status } from 'api/types'
import Actions from 'redux/actions'

type State = {
  name: string
  file: string
} & Status

const initialState: State = {
  name: '',
  file: '',
  isLoading: false,
  success: false,
  fail: false,
}

export default (
  state: State = initialState,
  action: CallAPIAction<
    Actions.GET_VISA_INVOICE_FILE_ASYNC,
    Actions.GET_VISA_INVOICE_FILE_SUCCESS,
    Actions.GET_VISA_INVOICE_FILE_FAIL,
    getInvoiceFileResponse
  >,
) => {
  switch (action.type) {
    case Actions.GET_VISA_INVOICE_FILE_SUCCESS:
      return {
        ...action.status,
        file: action.payload.bytes,
        name: action.payload.name,
      }
    case Actions.GET_VISA_INVOICE_FILE_ASYNC:
    case Actions.GET_VISA_INVOICE_FILE_FAIL:
      return {
        ...state,
        ...action.status,
      }
    default:
      return state
  }
}
